<div class="justify-center items-center flex align-middle h-12">© 2023 KOgent Systems, LLC. All rights reserved.</div>
